// src/msalConfig.js
export const msalConfig = {
  auth: {
     clientId: "cb91a62d-47b7-4385-a7d2-8456c6c8bd17",
     authority: "https://login.microsoftonline.com/906aefe9-76a7-4f65-b82d-5ec20775d5aa",
     redirectUri: "https://comcast-sso.rlpweb.com/",
     postLogoutUri: "https://comcast-sso.rlpweb.com/login",
     // Local
    //  clientId: "2db080ce-2df0-4c58-aaab-b539da393142",
    //  authority: "https://login.microsoftonline.com/2f9562b2-a4c1-41a4-b069-7b82367bba1f",
    //  redirectUri: "http://localhost:8080/",
    //  postLogoutUri: "http://localhost:8080/login",

  },
  cache: {
    cacheLocation: 'localStorage', // Can be 'localStorage' or 'sessionStorage'
    storeAuthStateInCookie: false, // Set to true for IE 11 or Edge
  },
};
